import { ImageSrcData } from '../Image/Image';

export enum MediaType {
  VIDEO = 'video',
  IMAGE = 'image',
}

interface ImageData {
  original?: ImageSrcData;
  thumbnail?: ImageSrcData;
  url?: string;
  alt?: string;
}

interface VideoData {
  src?: string;
  type?: string;
  previewSrc?: string;
  previewSrcSet?: string;
}

export interface MediaData extends ImageData, VideoData {
  mediaType: MediaType;
}

export const insideEditable = el =>
  ['INPUT', 'TEXTAREA'].includes(el.tagName) ||
  el.getAttribute('contenteditable');
